export default __webpack_public_path__ + "static/award-07-68a68194b91a2d9c9cfdae5e4f5da492.png";